import React, { useEffect, useMemo, useRef } from "react"
import { NewInputList, NewModal, MainContentPaddingTypes, NewInputListHandles } from "..";
import { ListStyle_Types, NewFieldStyles } from "../../Definitions";
import { colors, fonts } from "../../Styles";
import { useTerminals } from "../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/useTerminals";
import { useAppSelector } from "../../Store";
import { Graph_QL } from "../../Services";
import { useTranslation } from "react-i18next";
import { useSection } from "../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/useSections";
import { BoardData } from "./ioTable";

interface ioModalProps {
  selectedBoard: BoardData
  onNextBoard: () => void
  onPreviousBoard: () => void
  closeModal: () => void
}

export default function IoModal({selectedBoard, onNextBoard, onPreviousBoard, closeModal}:ioModalProps) {
  const {t} = useTranslation()
  const inputRefs = useRef<NewInputListHandles[]>([])
  
  const farm = useAppSelector(({activeData}) => activeData.farm) ?? "";
  const domain = useMemo(() => (Graph_QL.ObjToString({domain: farm})),[farm]);
  const connection = useMemo(() => (Graph_QL.create({domain: farm})),[farm]);

  const { call: getTerminals, data: terminals, updateTerminal } = useTerminals(connection)  
  const { call: getLfSectionsInfo, data: lfSectionsState } = useSection(connection);

  useEffect(() => {
    getTerminals({ fetchAmount: 10 })
    getLfSectionsInfo({fetchAmount: 50})
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // Section for pen name
  const sections = useMemo( () => (lfSectionsState[domain] ? lfSectionsState[domain].data : undefined), [domain, lfSectionsState] );

  // Filter terminals from selected board
  const terminalsFromBoard = useMemo(() => terminals[domain]?.data?.filter(
      terminal => terminal.fk_devices === selectedBoard.id
  ), [terminals, domain, selectedBoard.id]);

  console.log(terminalsFromBoard)

  // #region | Terminal info and update
  useEffect(() => {
    if (terminalsFromBoard !== undefined) {
      terminalsFromBoard.forEach((terminal, index) => {
        const ref = inputRefs.current[index];
        if (ref) {
          ref.refs.current[0].setValue(terminal.val1_max ?? "");
          ref.refs.current[1].setValue(terminal.val1_min ?? "");
          ref.refs.current[2].setValue(terminal.val1_type ?? "");
          ref.refs.current[3].setValue(terminal.val2_max ?? "");
          ref.refs.current[4].setValue(terminal.val2_min ?? "");
          ref.refs.current[5].setValue(terminal.val2_type ?? "");
          ref.refs.current[6].setValue(terminal.extra ?? "");
          ref.refs.current[7].setValue(terminal.programmed ?? "");
          ref.refs.current[8].setValue(terminal.time_act ?? "");
        } 
      });
    }
  }, [terminalsFromBoard, domain]);

  const UpdateData = () => {
    if (terminalsFromBoard !== undefined) {
      terminalsFromBoard.forEach((terminal, index) => {
        const ref = inputRefs.current[index];
        if (ref) {
          const config = {
            val1_max: Number(ref.refs.current[0].value) || undefined,
            val1_min: Number(ref.refs.current[1].value) || undefined,
            val1_type: Number(ref.refs.current[2].value),
            val2_max: Number(ref.refs.current[3].value) || undefined,
            val2_min: Number(ref.refs.current[4].value) || undefined,
            val2_type: Number(ref.refs.current[5].value) || undefined,
            extra: Number(ref.refs.current[6].value) || undefined,
            programmed: Number(ref.refs.current[7].value) || undefined,
            time_act: Number(ref.refs.current[8].value) || undefined
          };
          updateTerminal(terminal.terminal_id, config);
        }
      });
    }
  };
  // #endregion
 
  // #region | Terminal Component
  const TerminalComponent = useMemo(() => {
    let viewList: JSX.Element[] = [];

    // Fallback
    if (!terminalsFromBoard || terminalsFromBoard.length === 0) {
      return (
        <div style={{width: "100%", display: "flex", justifyContent: "center"}}>
          <p style={{ ...fonts.paragraph, ...fonts.fontSize4, color: colors.greyLightTertiary }}>{`${t("devices.noTerminals", {defaultValue: "No Terminals"})}!`}</p>
        </div>
      )
    }

    // Else
    terminalsFromBoard.forEach((terminal, terminalIndex) => {
      let viewElement: JSX.Element[] = [];

      let penName = sections?.flatMap(section => section.section_locations).find(location => location.location_id === terminal.fk_locations)?.name || terminal.fk_locations
      viewElement.push(<p key={'name_' + terminalIndex} style={{ ...fonts.paragraph, ...fonts.fontSize3, color: colors.greyLightTertiary }}>{`${t("devices.pen")}: `} <b>{penName}</b></p>)
    
      let terminalPort = terminal.port;
      viewElement.push(<p key={'port_' + terminalIndex} style={{ ...fonts.paragraph, ...fonts.fontSize3, color: colors.greyLightTertiary }}>{`${t("devices.terminalPort", {defaultValue: "Terminal Port"})}: `} <b>{terminalPort}</b></p>)

      let terminalType = terminal.fk_terminal_types;
      viewElement.push(<p key={'type_' + terminalIndex} style={{ ...fonts.paragraph, ...fonts.fontSize3, color: colors.greyLightTertiary }}>{`${t("devices.type", { defaultValue: "type" })}: `} <b>{terminalType}</b></p>)

      viewList.push(
        <div style={{ display: "flex", flexDirection: "column", gap: "5px", width: "100%" }}>
          <div style={{ display: "flex", flexDirection: "row", gap: "20px", alignItems: "center", justifyContent: "space-between" }}>
            <div style={{ display: "flex", flexDirection: "row", gap: "20px", alignItems: "center", justifyContent: "start" }}>
              {viewElement}
            </div>
            {/* <Button content={t("devices.moveBoard", {defaultValue: "move board"})}
            buttonType={ButtonTypes.textButton}
            endEnhancer={glyphs.Arrow({})}
          /> */}
          </div>
          <div style={{ width: "100%", boxSizing: "border-box", height: "fit-content", backgroundColor: colors.greyLightSecondary, padding: "10px 10px", borderRadius: "10px" }}>
            <NewInputList ref={(el) => { if (el) inputRefs.current[terminalIndex] = el }}
              headers={["val1_max", "val1_min", "val1_type", "val2_max", "val2_min", "val2_type", "extra", "programmed", "time_act"]}
              placeholders={Array(9).fill("")}
              isDisabled={Array(9).fill(false)}
              valueOverrides={{
                valueTypes: Array(9).fill("number")
              }}
              fieldOverrides={{
                fieldStyle: NewFieldStyles.greyTertiary
              }}
              listOverrides={{
                listStyle: ListStyle_Types.group,
              }}
            />
          </div>
        </div>
      );
    })
    
    return viewList; 
  }, [sections, t, terminalsFromBoard])
  // #endregion

  return (
    <NewModal 
      header={selectedBoard.name ?? ""}
      subHeader={`${t("devices.board", {defaultValue: "Board"})} ${selectedBoard.id}`}
      modalState={!!selectedBoard}
      predefinedButtons={{
        onClose: closeModal,
        onPrev: onPreviousBoard,
        onNext: onNextBoard
      }}
      overrides={{
        mainContentPadding: MainContentPaddingTypes.secondary
      }}
      secondaryContent={
        <div style={{maxWidth: "585px", display: "flex", flexDirection: "column", alignItems: "start", justifyContent: "center", gap: "40px"}}>
          {TerminalComponent}
        </div>
      }
      mainContent={ <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
        {/* <Button content={t("buttons.save", {defaultValue: "save"})} onClick={() => UpdateData()}
          buttonType={ButtonTypes.primaryButton}
          overrides={{
            baseButton: {...css.button_FitContent}
          }}
        /> */}
      </div> }
    />
  )
}
